// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_69f2db6c7f--spinner--uXgOG","circle-spin":"_69f2db6c7f--circle-spin--HhIQz"};